// The words for a mentor's live state, shared by the avatar menu switch, the
// Talk now popover and the Live now page.

// Why the server turned live off.
export const LIVE_OFF_REASONS: Record<string, string> = {
  missed_request: 'Paused while you were away',
  planned_session: 'Paused for your booked session',
  expired: 'Off: the 2 hours ended',
  disconnected: 'Off: you left GrowthMentor',
}

// Why the server refused to turn live on.
export const GO_LIVE_ERRORS: Record<string, string> = {
  planned_session_soon: 'A planned session starts in less than 20 min',
  not_eligible: 'Your profile is not public right now',
}

// "1 h 20 min", from now to the end of a mentor's live window.
const durationLeft = (liveUntil: string): string => {
  const minutes = Math.max(
    0,
    Math.round((new Date(liveUntil).getTime() - Date.now()) / 60000),
  )
  if (minutes < 60) return `${minutes} min`
  const hours = Math.floor(minutes / 60)
  const rest = minutes % 60
  return `${hours} h${rest ? ` ${rest} min` : ''}`
}

// "Live for 1 h 20 min more", in the Talk now popover.
export const liveForText = (liveUntil: string): string =>
  `Live for ${durationLeft(liveUntil)} more`

// "1 h 20 min left", in the rows of the Live now page.
export const timeLeftText = (liveUntil: string): string =>
  `${durationLeft(liveUntil)} left`
